export enum AgeGroupsTypes {
  ADULTS = 'ADULT',
  YOUNG = 'YOUNG'
}
